<script>
import minusIcon from '!!raw-loader!@/assets/images/controls/minus.svg';
import plusIcon from '!!raw-loader!@/assets/images/controls/plus.svg';

export default {
  name: 'AmountMultiplier',
  data() {
    return { minusIcon, plusIcon };
  },
  props: {
    settings: { type: Object, required: true },
    value: { type: Number, default: null }
  }
};
</script>

<template>
  <div class="amount-multiplier" :class="{ 'amount-multiplier-counter': settings.type === 'counter' }">
    <h4 :id="`amount-multiplier-label-${_uid}`" class="amount-multiplier-label">{{ settings.label }}</h4>
    <app-select
      v-if="settings.type === 'dropdown'"
      :value="value"
      :options="settings.presets.map((value) => ({ name: String(value), value }))"
      :reduce="(option) => option.value"
      :searchable="false"
      placeholder="Please select"
      :aria-labelledby="`amount-multiplier-label-${_uid}`"
      @input="$emit('input', $event)"
    />
    <div v-else class="amount-multiplier-controls" role="group" :aria-labelledby="`amount-multiplier-label-${_uid}`">
      <button type="button" aria-label="Decrease quantity" :disabled="value <= 1" @click="$emit('input', value - 1)">
        <span class="amount-multiplier-icon" aria-hidden="true" v-html="minusIcon"></span>
      </button>
      <span class="amount-multiplier-value" aria-live="polite">{{ value }}</span>
      <button type="button" class="amount-multiplier-increase" aria-label="Increase quantity" @click="$emit('input', value + 1)">
        <span class="amount-multiplier-icon" aria-hidden="true" v-html="plusIcon"></span>
      </button>
    </div>
  </div>
</template>
